var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.571 1C2.707 1 2 1.731 2 2.625v10.366C2 13.548 2.444 14 3 14c.552 0 1-.445 1-.996V3h8.002c.551 0 .998-.444.998-1 0-.552-.455-1-1.009-1zM6.6 4C5.72 4 5 4.75 5 5.667v11.666C5 18.25 5.72 19 6.6 19h8.8c.88 0 1.6-.75 1.6-1.667V5.667C17 4.75 16.28 4 15.4 4zM7 17V6h8v11z"
})));
export default SvgIconCopy;